import React from 'react';

const PaymentProcessIcon = ({ width = 70, height = 61, color = "#FE531F" }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 70 61"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            
                <path d="M49.8571 29.8945H45.8418L42.8162 41.9404H38.1505L34.5876 25.9923L31.0247 41.9404H26.359L23.3334 29.8945H19.3181V26.0205H22.372L20.5905 18.8948H25.5673L27.0094 26.0205H30.6005L32.1558 18.8948H37.2739L38.8574 26.0205H42.4203L43.8624 18.8948H48.5847L46.8032 26.0205H49.8571V29.8945ZM28.7343 34.4471L29.724 29.8945H27.8011L28.7343 34.4471ZM41.6568 29.8945H39.7057L40.7237 34.5319L41.6568 29.8945Z" fill={color} />
                <path d="M61.274 30.4681C61.274 45.5028 49.0318 57.7086 33.9083 57.7086C18.7848 57.7086 6.54259 45.5028 6.54259 30.4681C6.54259 15.4334 18.7848 3.22765 33.9083 3.22765C49.0318 3.22765 61.274 15.4334 61.274 30.4681Z" stroke={color} strokeWidth="4.94846" />

        </svg>

    );
};

export default PaymentProcessIcon;